import angular from 'angular';
import UIRouter from 'angular-ui-router';

import './styles/index.scss';
import template from './index.html';
import UnauthController from './UnauthController';

    
let namespace = angular.module('olr-mainfe-unauth', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.unauth', {
    url: '/unauth',
    controller: UnauthController,
    controllerAs: 'unauthCtrl',
    template: template
  });
});

namespace.controller('UnauthController', UnauthController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-unauth/index.js
 **/